import { Fragment } from "react";

import dates from "componentsv2/tools/dates";
import { classNames } from "tools/ui";
import { useContext } from "../store/useContext";

const DAYS = [
  "Domingo",
  "Lunes",
  "Martes",
  "Miércoles",
  "Jueves",
  "Viernes",
  "Sábado",
];

const DaysHeader = () => {
  return (
    <div className="grid grid-cols-7 gap-px border-b border-gray-300 bg-gray-200 text-center text-xs/6 font-semibold text-gray-700 lg:flex-none sticky top-12">
      {DAYS.map((day, index) => (
        <div key={index} className="bg-white py-2">
          {day[0]}
          <span className="sr-only sm:not-sr-only">{day.slice(1)}</span>
        </div>
      ))}
    </div>
  );
};

function MonthView({ newDays, handleDay, handleEvent, handleDetail }) {
  const { context } = useContext();
  const { currentDate } = context;

  const getPatientName = (event) => {
    return (
      event.item?.["patient."]?.rec_name || event.patient || "Sin paciente"
    );
  };
  function onClickDetail(e, day, events) {
    e.stopPropagation();
    e.preventDefault();
    handleDetail(e, day, events);
  }

  function handleClickDay(e, item) {
    const { day, events, disabled } = item;

    const sameMonth = day.getMonth() === currentDate.getMonth();
    if (disabled || !sameMonth) return;

    e.stopPropagation();
    e.preventDefault();
    handleDay(e, day, events);
  }

  return (
    <Fragment>
      <DaysHeader />
      <div className="flex bg-gray-200 text-xs/6 text-gray-700 lg:flex-auto h-[calc(100vh)]">
        <div className="hidden w-full h-full lg:grid lg:grid-cols-7 lg:grid-rows-[repeat(6,1fr)] lg:gap-px">
          {newDays.map((day) => (
            <div
              key={day.dayString}
              className={classNames(
                day.isCurrentMonth && !day.disabled
                  ? "bg-white"
                  : "bg-gray-50 text-gray-500",
                "relative px-3 py-2 cursor-pointer",
              )}
              onClick={(e) => handleClickDay(e, day)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  handleClickDay(e, day);
                }
              }}
              tabIndex={0}
              role="button"
            >
              <time
                dateTime={day.dayString}
                className={
                  day.isToday
                    ? "flex size-6 items-center justify-center rounded-full bg-indigo-600 font-semibold text-white"
                    : ""
                }
              >
                {dates.fmt(day.day, "d")}
              </time>
              {day.events.length > 0 && (
                <ol className="mt-2 space-y-1">
                  {day.events.slice(0, 2).map((event) => (
                    <li
                      key={event.id}
                      className="group flex cursor-pointer bg-green-200 px-1 rounded-md"
                      onClick={(e) => handleEvent(e, event)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          handleEvent(e, event);
                        }
                      }}
                      tabIndex={0}
                      role="button"
                    >
                      <p className="flex-auto truncate font-medium text-gray-900 group-hover:text-indigo-600">
                        {getPatientName(event)}
                      </p>
                      <time
                        dateTime={dates.fmt(
                          event.start_date,
                          "yyyy-MM-dd HH:mm",
                        )}
                        className="ml-3 hidden flex-none text-gray-500 group-hover:text-indigo-600 xl:block"
                      >
                        {dates.fmt(event.start_date, "HH:mm aa")}
                      </time>
                    </li>
                  ))}
                  {day.events.length > 2 && (
                    <li
                      className="text-gray-500"
                      onClick={(e) => onClickDetail(e, day, day.events)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          onClickDetail(e, day, day.events);
                        }
                      }}
                      tabIndex={0}
                      role="button"
                    >
                      + {day.events.length - 2} more
                    </li>
                  )}
                </ol>
              )}
            </div>
          ))}
        </div>
        <div className="isolate grid w-full grid-cols-7 grid-rows-6 gap-px lg:hidden">
          {newDays.map((day) => (
            <button
              key={day.dayString}
              type="button"
              onClick={(e) => handleDetail(e, day)}
              className={classNames(
                day.isCurrentMonth ? "bg-white" : "bg-gray-50",
                (day.isSelected || day.isToday) && "font-semibold",
                day.isSelected && "text-white",
                !day.isSelected && day.isToday && "text-indigo-600",
                !day.isSelected &&
                  day.isCurrentMonth &&
                  !day.isToday &&
                  "text-gray-900",
                !day.isSelected &&
                  !day.isCurrentMonth &&
                  !day.isToday &&
                  "text-gray-500",
                "flex h-full flex-col px-3 py-2 hover:bg-gray-100 focus:z-10",
              )}
            >
              <time
                dateTime={day.dayString}
                className={classNames(
                  day.isSelected &&
                    "flex size-6 items-center justify-center rounded-full",
                  day.isSelected && day.isToday && "bg-indigo-600",
                  day.isSelected && !day.isToday && "bg-gray-900",
                  "ml-auto",
                )}
              >
                {dates.fmt(day.day, "d")}
              </time>
              <span className="sr-only">{day.events.length} events</span>
              {day.events.length > 0 && (
                <span className="-mx-0.5 mt-auto flex flex-wrap-reverse">
                  {day.events.map((event) => (
                    <span
                      key={event.id}
                      className="mx-0.5 mb-1 size-1.5 rounded-full bg-gray-400"
                    />
                  ))}
                </span>
              )}
            </button>
          ))}
        </div>
      </div>
    </Fragment>
  );
}

export default MonthView;
